import { render, staticRenderFns } from "./CheckoutUserCoupons.vue?vue&type=template&id=5281753e&"
import script from "./CheckoutUserCoupons.vue?vue&type=script&lang=js&"
export * from "./CheckoutUserCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5281753e')) {
      api.createRecord('5281753e', component.options)
    } else {
      api.reload('5281753e', component.options)
    }
    module.hot.accept("./CheckoutUserCoupons.vue?vue&type=template&id=5281753e&", function () {
      api.rerender('5281753e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/CheckoutUserCoupons.vue"
export default component.exports